import { render, staticRenderFns } from "./ScreenCardActions.vue?vue&type=template&id=2bd2c498&scoped=true&"
import script from "./ScreenCardActions.vue?vue&type=script&lang=js&"
export * from "./ScreenCardActions.vue?vue&type=script&lang=js&"
import style0 from "./ScreenCardActions.vue?vue&type=style&index=0&id=2bd2c498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd2c498",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
